import { useTranslation } from "react-i18next";
import StarRating from "@/components/StarRating/StarRating";
import ReviewResponse from "@/model/ReviewResponse";
import isoDate from "@/utils/isoDate";
import "@/components/ReviewCard/ReviewCard.scss";

interface ReviewCardProps {
  review: ReviewResponse;
}

function ReviewCard({ review }: ReviewCardProps) {
  const { t, i18n } = useTranslation();
  const stayedIn = review.stayedOn
    ? isoDate.parseIsoDate(review.stayedOn).toLocaleDateString(i18n.language, {
        month: "long",
        year: "numeric",
      })
    : null;

  return (
    <article className="review-card">
      <header className="review-card__header">
        <span className="review-card__avatar" aria-hidden="true">
          {(review.authorName ?? "?").charAt(0)}
        </span>
        <div>
          <p className="review-card__author">
            {review.authorName}
            {review.mine && (
              <span className="review-card__mine">
                {t("reviews.yourReview")}
              </span>
            )}
          </p>
          {stayedIn && (
            <p className="review-card__meta">
              {t("reviews.stayedIn", { month: stayedIn })}
            </p>
          )}
        </div>
      </header>
      <StarRating value={review.rating ?? 0} size="small" />
      <p className="review-card__comment">{review.comment}</p>
    </article>
  );
}

export default ReviewCard;
export type { ReviewCardProps };
